import { uniqueId } from 'lodash';

import {
  DashboardNavbarSetting,
  Organization,
  OrganizationAttributes,
  OrganizationRelationships,
  OrganizationStatus,
} from 'dashboard/models/organization';
import { ApiModel } from 'lib/interfaces/api';

export const generateOrganizationId = () => uniqueId('org_');

export function createMockOrganization(
  attributes?: Partial<OrganizationAttributes>,
  relationships?: Partial<OrganizationRelationships>,
  id?: string,
): Organization {
  return {
    attributes: {
      name: 'Acme',
      status: OrganizationStatus.Active,
      slug: 'acme',
      'has-saml-enabled': false,
      subdomain: null,
      timezone: null,
      'billing-info': null,
      'disable-required-onboarding-quiz': false,
      'onboarding-checklist-sandbox-completed-steps': [],
      'allowed-hosts': [],
      'allowed-uri-schemes': [],
      'mfa-required-at': null,
      'saml-required-at': null,
      'enabled-mfa-methods': [],
      'product-features': [],
      'inquiry-hosted-flow-custom-domain': null,
      'customer-tier': null,
      'session-length-seconds': null,
      'refresh-session-on-activity': false,
      'idp-metadata': null,
      'dashboard-navbar-setting': DashboardNavbarSetting.RoleBased,
      industry: null,
      'retention-period-seconds': null,
      ...attributes,
    },
    id: id || generateOrganizationId(),
    relationships: {
      environments: {
        data: [
          {
            id: 'env_production',
            type: ApiModel.EnvironmentProduction,
          },
          {
            id: 'env_sandbox',
            type: ApiModel.EnvironmentSandbox,
          },
        ],
      },
      'current-organization-plan': {
        data: { type: ApiModel.OrganizationPlan, id: 'current_plan_id' },
      },
      'pending-organization-plan-migration': {
        data: { type: ApiModel.OrganizationPlanMigration, id: 'current_org_plan_migration_id' },
      },
      'theme-set': {
        data: { type: ApiModel.ThemeSet, id: 'current_theme_set_id' },
      },
      ...relationships,
    },
    type: ApiModel.Organization,
  };
}
